
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GammaPetitionDetailsDataExperiments"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sunriseSupportersV1"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supporterShareVisualsExperiment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signatureThermometerExperimentDesktop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mobileAppDownloadBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"googleAddressExperiment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"googleAddressExperimentLocal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullSunrisePetitionPageShareComponentExperiment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullSunrisePetitionHeaderExperiment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actionPanelSunriseExperiment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gdprSignOptInCopy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"newPetitionPageRemoveRfs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":true}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"platypusPetitionSignGooglePrefillExperiment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"treat"},"value":{"kind":"BooleanValue","value":false}}],"directives":[]}]}}]}}],"loc":{"start":0,"end":612}};
    doc.loc.source = {"body":"query GammaPetitionDetailsDataExperiments {\n\texperiments {\n\t\tsunriseSupportersV1(treat: true)\n\t\tsupporterShareVisualsExperiment(treat: true)\n\t\tsignatureThermometerExperimentDesktop(treat: true)\n\t\tmobileAppDownloadBanner(treat: true)\n\t\tgoogleAddressExperiment(treat: true)\n\t\tgoogleAddressExperimentLocal(treat: true)\n\t\tfullSunrisePetitionPageShareComponentExperiment(treat: true)\n\t\tfullSunrisePetitionHeaderExperiment(treat: true)\n\t\tactionPanelSunriseExperiment(treat: true)\n\t\tgdprSignOptInCopy(treat: true)\n\t\tnewPetitionPageRemoveRfs(treat: true)\n\t\tplatypusPetitionSignGooglePrefillExperiment(treat: false)\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GammaPetitionDetailsDataExperiments"] = oneQuery(doc, "GammaPetitionDetailsDataExperiments");
        
